export enum IdentifierType {
    CNK = 'cnk',
    INN = 'inn',
    VMP = 'vmp',
    EAN = 'ean',
    COMPOUND = 'compound'
};
